module.exports = __webpack_public_path__ + "static/media/DiagnosesIcon.4ecd8fa9.svg";